/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_JSON_RESPONSE (state, payload) {
    state.json_response = payload
  },
  REMOVE_JSON_RESPONSE (state) {
    // const userIndex = state.users.findIndex((u) => u.id === itemId)
    state.json_response = null
  }
}
